var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEffective(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 32,
    viewBox: "0 0 30 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#D4EEFF",
    d: "M10 32h10V10H10z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#15b2ec",
    d: "M20 32h10V0H20z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#15b2ec",
    d: "M0 32h10V19H0z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEffective);
export default __webpack_public_path__ + "static/media/effective.d94f80adf1464352d45d1c6fb906873c.svg";
export { ForwardRef as ReactComponent };